@if (brands$ | async; as brands) {
  <p-carousel
    [autoplayInterval]="5000"
    [circular]="true"
    [numScroll]="1"
    [numVisible]="5"
    [responsiveOptions]="responsiveOptions()"
    [showIndicators]="false"
    [value]="brands">
    <ng-template
      #item
      let-brand>
      <app-router-link
        [route]="Route.PL_BrandDetails"
        [params]="routerLinkParams(brand.slug)"
        queryParamsHandling="preserve">
        <app-public-highlighted-brand-tile
          [name]="brand.name"
          [logoAlt]="brand.logoAlt"
          [logoSrc]="brand.logoSrc" />
      </app-router-link>
    </ng-template>
  </p-carousel>
} @else {
  <app-spinner-filled />
}
